import { OHIF } from '@gleamer/types';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { ToolMouseBindings } from './ToolMouseBindings';

type ToolConfigBinding = OHIF.ToolConfigBinding;

export type MouseToolConfig = {
  toolName: string;
  bindings: ToolConfigBinding[];
};

export function MouseBindings({
  configs,
  onChange,
}: {
  configs: MouseToolConfig[];
  onChange: (toolName: string, bindings: ToolConfigBinding[]) => void;
}) {
  const { t } = useTranslation('UserPreferencesModal');
  return (
    <div className="grid grid-cols-2 w-full gap-x-6 gap-y-4">
      <h6 className="text-primary-light m-0 w-full text-right text-lg leading-tight">
        {t('Function')}
      </h6>
      <h6 className="text-primary-light m-0 text-left text-lg leading-tight">
        {t('Mouse binding')}
      </h6>
      {configs.map(config => {
        return (
          <Fragment key={config.toolName}>
            <h6 className="m-0 flex h-8 items-center justify-end whitespace-nowrap text-right text-lg leading-tight text-white">
              {config.toolName.replace(/([A-Z])/g, ' $1')}
            </h6>
            <ToolMouseBindings
              toolName={config.toolName}
              className="flex flex-col gap-1"
              configs={configs}
              bindings={config.bindings}
              onChange={toolBindings => onChange(config.toolName, toolBindings)}
            />
          </Fragment>
        );
      })}
    </div>
  );
}
